// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NIBZiS1bDfBAHu_W9Lgj{font-size:13px;color:var(--color-main);font-weight:bold}.N2m9P6KNRWu_VNkWrpmj{font-size:14px}`, "",{"version":3,"sources":["webpack://./src/components/listings/DefaultFilterInput/components/FilterList/styles.module.sass"],"names":[],"mappings":"AAAA,sBACE,cAAA,CACA,uBAAA,CACA,gBAAA,CACF,sBACE,cAAA","sourcesContent":[".buttonContent\n  font-size: 13px\n  color: var(--color-main)\n  font-weight: bold\n.buttonContentSize\n  font-size: 14px"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonContent": `NIBZiS1bDfBAHu_W9Lgj`,
	"buttonContentSize": `N2m9P6KNRWu_VNkWrpmj`
};
export default ___CSS_LOADER_EXPORT___;
